document.addEventListener('DOMContentLoaded', function() {

  function handleCheckboxChange(checkbox) {
    const hiddenInputId = checkbox.dataset.hiddenInputId;
    const hiddenInput = document.getElementById(hiddenInputId);
    if (hiddenInput) {
      hiddenInput.value = checkbox.checked ? 'Yes' : 'No';
    }
  }

  function handleTextInputChange(input) {
    const hiddenInputId = input.dataset.hiddenInputId;
    const hiddenInput = document.getElementById(hiddenInputId);
    if (hiddenInput) {
      hiddenInput.value = input.value;
    }
  }

  // Build the line item property value from key + label.
  // See docs/adr/0001-bundle-product-frame-color-as-metafield.md
  function getLineItemValue(input) {
    var label;
    if (input.tagName === 'SELECT') {
      var selected = input.options[input.selectedIndex];
      label = selected && selected.dataset.optionLabel;
    } else {
      label = input.dataset.optionLabel;
    }
    if (label) {
      return label + ' (' + input.value + ')';
    }
    return input.value;
  }

  function handleOptionInputChange(optionInputs) {
    optionInputs.forEach(input => {
      const productFormInput = document.getElementById(`product-form-input-${input.dataset.optionName}-${input.dataset.blockId}`);
      if (!productFormInput) {
        return;
      }

      function updateFields(input) {
        productFormInput.value = getLineItemValue(input);
      }

      input.addEventListener('change', function() {
        updateFields(this);
      });

      if (input.checked || input.tagName === 'SELECT') {
        updateFields(input);
      }
    });
  }

  const customCheckboxes = document.querySelectorAll('.custom-checkbox-input');
  customCheckboxes.forEach(checkbox => {
    checkbox.addEventListener('change', function() {
      handleCheckboxChange(checkbox);
    });
  });

  const customTextInputs = document.querySelectorAll('.custom-text-field');
  customTextInputs.forEach(input => {
    input.addEventListener('input', function() {
      handleTextInputChange(input);
    });
  });

  const optionInputs = document.querySelectorAll('input[name^="custom_option_"], select[name^="custom_option_"]');
  if (optionInputs.length > 0) {
    handleOptionInputChange(optionInputs);
  }

  // Thumbnail scroller: toggle active class + update label
  document.querySelectorAll('.frame-thumbnail input[type="radio"]').forEach(function(radio) {
    radio.addEventListener('change', function() {
      var track = this.closest('.frame-thumbnail-track');
      if (track) {
        track.querySelectorAll('.frame-thumbnail').forEach(function(t) {
          t.classList.remove('frame-thumbnail--active');
        });
        this.closest('.frame-thumbnail').classList.add('frame-thumbnail--active');
      }
      var labelSpan = document.getElementById('selected' + this.dataset.optionName);
      if (labelSpan) {
        labelSpan.textContent = this.dataset.optionLabel;
      }
    });
  });

  // Frame Model -> Gallery image swap
  function initFrameMediaSwap() {
    const gallery = document.querySelector('media-gallery');
    if (!gallery) return;

    const mapAttr = gallery.getAttribute('data-frame-media-map');
    if (!mapAttr) return;

    let frameMediaMap;
    try {
      frameMediaMap = JSON.parse(mapAttr);
    } catch (e) {
      return;
    }

    const allFrameValues = Object.keys(frameMediaMap);
    if (allFrameValues.length === 0) return;

    // Collect all media IDs that belong to ANY frame model
    const allFrameMediaIds = new Set();
    for (const ids of Object.values(frameMediaMap)) {
      ids.forEach(id => allFrameMediaIds.add(id));
    }

    function filterGallery(selectedValue) {
      const viewer = gallery.querySelector('[id^="GalleryViewer"]');
      const thumbnails = gallery.querySelector('[id^="GalleryThumbnails"]');
      if (!viewer) return;

      const allSlides = viewer.querySelectorAll('[data-media-id]');
      const allThumbs = thumbnails
        ? thumbnails.querySelectorAll('[data-target]')
        : [];

      const matchingIds = frameMediaMap[selectedValue] || [];
      const matchingSet = new Set(matchingIds);
      let firstMatchId = null;

      allSlides.forEach(slide => {
        const mediaId = slide.dataset.mediaId;
        if (allFrameMediaIds.has(mediaId)) {
          // This image belongs to a frame model
          if (matchingSet.has(mediaId)) {
            slide.style.display = '';
            if (!firstMatchId) firstMatchId = mediaId;
          } else {
            slide.style.display = 'none';
            slide.classList.remove('is-active');
          }
        }
        // Images not in any frame group stay visible (generic images)
      });

      allThumbs.forEach(thumb => {
        const target = thumb.dataset.target;
        if (allFrameMediaIds.has(target)) {
          thumb.style.display = matchingSet.has(target) ? '' : 'none';
        }
      });

      // Activate the first matching image
      if (firstMatchId && gallery.setActiveMedia) {
        gallery.setActiveMedia(firstMatchId, false);
      } else if (firstMatchId) {
        const firstMatch = viewer.querySelector(
          `[data-media-id="${firstMatchId}"]`
        );
        if (firstMatch) {
          allSlides.forEach(s => s.classList.remove('is-active'));
          firstMatch.classList.add('is-active');
        }
      }

      // Update slider counter if present
      const counter = gallery.querySelector('.slider-counter--total');
      if (counter) {
        const visibleCount = viewer.querySelectorAll(
          '[data-media-id]:not([style*="display: none"])'
        ).length;
        counter.textContent = visibleCount;
      }

      // Reset slider position
      const sliderEl = viewer.querySelector('.slider');
      if (sliderEl) sliderEl.scrollTo({ left: 0 });
    }

    // Listen to all custom option inputs (radios and selects)
    const optionInputs = document.querySelectorAll(
      'input[name^="custom_option_"], select[name^="custom_option_"]'
    );
    optionInputs.forEach(input => {
      input.addEventListener('change', function () {
        filterGallery(this.value);
      });
    });

    // Apply on page load for the initially selected value
    const initialInput = document.querySelector(
      'input[name^="custom_option_"]:checked, select[name^="custom_option_"]'
    );
    if (initialInput) {
      filterGallery(initialInput.value);
    }
  }

  initFrameMediaSwap();
});
